/**
 * La manutention d'une commande, résumée pour le kanban et le calendrier.
 *
 * null s'il n'y en a pas. Le temps prévu vient de l'API (retard_livraison,
 * RetardLivraisonService), le montant de la commande : rien n'est recalculé ici.
 * Le besoin de deux livreurs se lit dans `manutention_deux_personnes`, fourni par
 * le serveur — la règle des 40 kg n'a pas à exister en double.
 */
export const manutentionResume = (order) => {
  const montantHT = parseFloat(order?.manutention_total_ht) || 0;
  const aConfirmer = order?.manutention_status === 'a_confirmer';

  if (montantHT <= 0 && !aConfirmer) return null;

  const minutes = order?.retard_livraison?.minutes_manutention || 0;
  const montant = montantHT.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return {
    aConfirmer,
    libelle: aConfirmer
      ? 'à confirmer'
      : `${montant} € HT${minutes ? ` · ~${minutes} min` : ''}`,
  };
};
